import React from "react";
import validString  from '../../services/VariableTools';
import {removeHTMLtags} from '../../services/VariableTools';
import renderLoader from '../base/Loader';
import '../css/App.scss';
import ApplyButton from "../position/ApplyButton";
import {generateJobIconUrl} from "../../services/ApiService";
import {getStyle} from "../../services/Style";
import Regions from "./Description/Regions";
import Youtube from "./Description/Youtube";
import EmploymentForm from "./Description/EmploymentForm";
import '../css/Position.scss';
import PropTypes from "prop-types";
import ShareButtons from "./Description/ShareButtons";
import ButtonLinkPrimary from "../Buttons/ButtonLinkPrimary";
import Certificates from "./Description/Certificates";
import Skills from "./Description/Skills";
import OtherBenefits from "./Description/OtherBenefits";
import Footer from "./Description/Footer";
import Summary from "./Description/Summary";
import PositionExpiredInvalid from "./PositionExpiredInvalid";
import CompanyDescription from './Description/CompanyDescription';

export default class JobDescription extends React.Component {

    static propTypes = {
        customerName: PropTypes.string.isRequired,
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        language: PropTypes.string.isRequired,
        customerData: PropTypes.objectOf(Promise).isRequired,
        positionData: PropTypes.objectOf(Promise).isRequired
    };

    constructor(props){
        super(props);
        this.state = {
            loading: true,
            title: null,
            publicationLanguage: this.props.language};
        this.loadData();
    }

    loadData = () =>  {
        this.props.positionData.then((PositionData) => {
            this.setState({loading: false, data: PositionData, publicationLanguage: PositionData && PositionData.success ? PositionData.result.language : this.props.language});
        });
        Promise.all([this.props.customerData, this.props.positionData]).then(([customerData, PositionData]) => {
            if (PositionData && PositionData.success) {
                document.title = [PositionData.result.data.name, customerData.result.name].join(' - ');
            }
        });
    };

    renderDescriptionSection = (title, content, icon) => {
        if (!validString(content)) {
            return null;
        }
        return (
            <div className="responsibilities details-section">
                <h4>
                    <i className={"padding-right-15 padding-top-15 padding-bottom-15 fa fa-" + icon}> </i>
                    {title}
                </h4>
                { content !== undefined && content !== null && <div dangerouslySetInnerHTML={{__html: content}}/>}
            </div>
        );
    };

    t = (slug) => {
        let {publicationLanguage} = this.state;
        return window.Translator.getSlug(slug, publicationLanguage);
    };

    renderPosition = data => {
        let dataJson = data.result.data;

        return (
            <>
                <div className="job-title-and-info">
                    <div className="title">
                        <div className="thumb d-none d-sm-none d-md-block"
                             style={getStyle(this.props.positionId, 'logoImage', this.props.customerName)}>
                            <img src={generateJobIconUrl(dataJson.jobIcon, dataJson.jobIconUpload)}
								 className="img-fluid" alt =""
								 onError={(e)=>{e.target.onerror = null; e.target.src="/gate/images/job/read-more.svg"}}/>
                        </div>
                        <div className="title-body">
                            <div className="info title-info" style={getStyle(this.props.positionId, 'title-info', this.props.customerName)}>
								<h4>{dataJson.name}</h4>
                                <div className={"displayFlex"}>
                                    <Regions regions={data.result.position_export_region}
                                             className={"padding-right-5 fa fa-map-marker-alt"}/>
                                </div>
                                <div className={"displayFlex"}>
                                    <EmploymentForm employmentForm={data.result.employment_form}/>
                                </div>
                                {dataJson.salary_text && dataJson.salary_text.length > 0 &&
                                <div className={"displayFlex"}>
                                    <span>
                                        <i className={"darkGray padding-right-5 fa fa-money-bill-alt"}/>
                                        {removeHTMLtags(dataJson.salary_text)}
                                    </span>
                                </div>}
                            </div>
                        </div>
                    </div>
                    <div className="buttons">
                        <ApplyButton
                            language={this.props.language}
                            customerName={this.props.customerName}
                            positionId={this.props.positionId}
                        />
                    </div>
                </div>
                <div className="details-information section-padding-30">
                    <div className="row">
                        <div className="col-xl-7 col-lg-8">
	                        {dataJson.intro && (
		                        <div className="intro-text details-section" dangerouslySetInnerHTML={{__html: dataJson.intro}}>
		                        </div>
	                        )}
                            <Youtube source={dataJson.youtube}/>
                            {this.renderDescriptionSection(this.t('JobDescription'), dataJson.job_note, 'align-left')}
                            {this.renderDescriptionSection(this.t('OtherRequirements'), dataJson.other_requirements, 'book')}
                            {dataJson.benefit &&
                            <div className="other-benifit details-section ">
                                <h4>
                                    <i className={"padding-right-15 padding-top-15 padding-bottom-15 far fa-thumbs-up"}> </i>
                                    {this.t('OtherBenefits')}
                                </h4>
                                <div dangerouslySetInnerHTML={{__html: dataJson.benefit}}/>
                            </div>}
                            <Skills
                                skills={data.result.skills}
                                language={this.state['publicationLanguage']}
								customerName={this.props.customerName}
								positionId={this.props.positionId}
							/>
                            <Certificates
                                certificates={data.result.certificates}
                                language={this.state['publicationLanguage']}
                            />
                            {dataJson.personal_prerequisites &&
                            <div className="other-benifit details-section margin-bottom-30">
                                <h4>
                                    <i className={"padding-right-15 padding-top-15 padding-bottom-15 fa fa-info"}> </i>
                                    {this.t('PersonalityRequirements')}
                                </h4>
                                <div
                                    dangerouslySetInnerHTML={{__html: dataJson.personal_prerequisites}}/>
                            </div>}
                            <OtherBenefits
                                language={this.state['publicationLanguage']}
                                content={dataJson.interview}
                            />
                            <div className="details-section job-apply-buttons  no-border row">
                                <ApplyButton
                                    language={this.props.language}
                                    customerName={this.props.customerName}
                                    positionId={this.props.positionId}
                                />
                                <ButtonLinkPrimary
                                    positionId={this.props.positionId}
                                    customerName={this.props.customerName}
                                    className={"col-12 col-xs-6 col-md-4 alterButton button button-email-position"}
                                    href={"mailto:?subject=" + dataJson.name + "&body=" + window.location.href}
                                    buttonType={"button-email-position"}
                                    usePrimary={false}>
                                    {window.Translator.getSlug('RecommendJob', this.props.language)}
                                </ButtonLinkPrimary>
                            </div>
                        </div>

                        <div className="col-xl-4 offset-xl-1 col-lg-4">
                            <div className="information-and-share">
                                <Summary
                                    data={dataJson}
                                    language={this.state['publicationLanguage']}
									positionId={this.props.positionId}
									customerName={this.props.customerName}
                                />
                                <ShareButtons
                                    language={this.props.language}
                                    link={window.location.href}
                                    positionId={this.props.positionId}
                                    customerName={this.props.customerName}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
					<CompanyDescription
						language={this.state['publicationLanguage']}
						companyName={dataJson.companyName}
						companyDescription={dataJson.companyDescription}
					/>
                    <Footer
                        language={this.state['publicationLanguage']}
                        customerData={this.props.customerData}
                        consultant={data.result.data.user}
                        customerName={this.props.customerName}
                    />
                </div>
            </>
        );
    };

    render() {
        if (!this.state['loading'] && (!this.state['data'] || !this.state['data'].success)) {
            return (
                <PositionExpiredInvalid
                customerName={this.props.customerName}
                positionId={this.props.positionId}
                language={this.props.language}
                reason={this.state['data'] && this.state['data']['reason'] ? this.state['data']['reason'] : null}
                />
            );
        }
        return (
            <div className="section-padding-bottom alice-bg flexHeight">
                <div className="alice-bg padding-top-30 section-padding-bottom flexHeight2"
                     style={getStyle(this.props.positionId, 'backgroundColor', this.props.customerName)}>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="job-listing-details job-detail-position">
                                    {this.state['loading'] ? renderLoader("jobsLoader") : this.renderPosition(this.state['data'])}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
